import React, { useEffect, useState } from "react";
import "../../Assets/styles/FloatingMenu.css";

const FloatingMenu = () => {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleLinkClick = (e, targetId) => {
    e.preventDefault();

    const section = document.querySelector(targetId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    setOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // show menu only after scrolling
      if (scrollPosition > 200) {
        setVisible(true);
      } else {
        setVisible(false);
        setOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`floating-menu-wrapper ${visible ? "visible" : "hidden"}`}>
      <button
        className={`floating-menu-btn ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Open navigation menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`floating-menu-panel ${open ? "show" : ""}`}>
      <a href="#timeline" onClick={(e) => handleLinkClick(e, "#timeline")}>
        A nossa história
      </a>
      <a href="#details" onClick={(e) => handleLinkClick(e, "#details")}>
        Detalhes e Localização
      </a>
      <a href="#accommodation" onClick={(e) => handleLinkClick(e, "#accommodation")}>
        Alojamento
      </a>
      <a href="#honeymoon" onClick={(e) => handleLinkClick(e, "#honeymoon")}>
        Lua de Mel
      </a>
      <a href="#rsvp" onClick={(e) => handleLinkClick(e, "#rsvp")}>
        RSVP
      </a>
      </div>
    </div>
  );
};

export default FloatingMenu;